import { defineComponent } from 'vue';
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default defineComponent({
  name: 'BarChartComponent',
  components: { Bar },
  props: {
    chartData: {
      type: Object
    },
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 300
    },
  },
  setup: () => {
    const chartOptions = {
      maintainAspectRatio: false,
      scales: {
        y: {
          ticks: {
            callback: (value: number) => { if (value % 1 === 0) { return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); } }
          }
        }
      }
    };

    return {
      chartOptions,
    };
  }
});
